
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
//grid
import { AgGridNg2 } from 'ag-grid-angular';

import { Motivo } from '../Models/Motivo';

import { GlobalsService } from '../services/globals.service';
import { MotivoService } from '../services/motivo.service';


@Component({
  selector: 'app-motivo',
  templateUrl: './motivo.component.html',
  styleUrls: ['./motivo.component.css']
})
export class MotivoComponent implements OnInit {

  public motivo: Motivo = new Motivo();
  public motivos: Motivo[];

  public modoEdicion: boolean = false;


  @ViewChild('agGrid') agGrid: AgGridNg2;
  title = 'Motivos';
  columnDefs = [
    { headerName: 'Código', field: 'idMotivo', icons: { filter: ' ' } },
    { headerName: 'Descripción', field: 'descripcion', icons: { filter: ' ' } }
  ];

  rowData: any[];

  
  constructor(
    private motivoService:MotivoService,
    private globalServices: GlobalsService) {

  }
  ngOnInit() {

    this.CargarMotivos();

  }



  /**
   * Obtiene todos los motivos de la compañia
   */
  CargarMotivos() {
    try {

      this.motivoService.ObtenerMotivos(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.motivos = data;
         this.rowData = this.motivos;

        },
        err => {
          console.clear();
          console.log(err._body);

        });

    } catch (error) {
      console.log("CargarMotivos: " + error);
    }

  }

  NuevoRegistro() {
    this.motivo = new Motivo();
    this.modoEdicion = true;

  }

  CancelarEdicion() {
    this.motivo = new Motivo();
    this.modoEdicion = false;

  }


  //cuando le da click al row de tabla
  private onCellClicked($event) {
    try {

      console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
      let row = $event.rowIndex;
      let datos = JSON.parse(JSON.stringify($event.data));

      this.motivo = datos;
      this.modoEdicion = true;
    } catch (error) {
      console.log("oncellclick: " + error);
    }
  }


//Inseta o actualiza el motivo
GuardarRegistro() {

  this.motivo.idCompania = this.globalServices.ObtenerCompania();

  this.motivoService.GuardarRegistroMotivo(this.motivo).subscribe(
    data => {

      swal("Registro guardado con éxito!", "", "success");

      this.motivo = new Motivo();
      this.modoEdicion = false;

      this.CargarMotivos();

    },
    err => {
      console.error(err);
      swal("Hubo un error a la hora de la ejecución", "", "error");
    }

  );



}

}
